<template>
  <div class="main-container">

    <div style="width: 100%;">
      <el-input
        style="max-width: 200px;"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>

  <transition :css="false">
  <el-dialog title="" :visible.sync="showModal">
     <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <div class="heading">
              <h2 class="login-title">Make Your Payment</h2>
            </div>
            <form>
              <arnergy-input label="First name" :model="firstName" disabled />
              <arnergy-input :model="lastName" label="Last name" disabled />
              <arnergy-input label="Email" :model="email" disabled />
              <label class="text-dark">Amount</label>
            </form>
            <div class="paying-now">
              <span>Paying now</span>
              <span>
                NGN{{ (500000 + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
              </span>
            </div>

            <!-- real footer item -->
            <button @click="flutterwavePay" class="submit-button" type="button">
              Make Payment
            </button>
            <div class="footer-lock">
              <i class="fa fa-lock"></i>
              <small class="small">
                Payment are encrypted using 256-bit SSL
              </small>
            </div>
            <p class="space small">
              By clicking
              <span>"Make Payment"</span>
              you acknowledge that you have read and agree to our
              <a class="link" href="#">Terms of Use</a>
              and
              <a class="link" href="#">Privacy Policy</a>
              ; you will e charged the same price every 12months untill you
              cancel your membership or complete payment. You may cancel
              subscription by accessing Account settings section on your
              dashboard.
            </p>
          </div>
        </div>
      </div>

  </el-dialog>
  </transition>
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Due Payments</h2>
      </div>

      <div>
        <vue-good-table
          :columns="cxTeamFields"
          :rows="getUsersAdmin"
          :search-options="{ enabled: true, externalQuery: searchTerm }"
          :pagination-options="{ enabled: true }"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <!-- {{1}} -->
            <span v-if="props.column.field == 'full_name'">
              {{ props.row.firstname }} {{ props.row.lastname }}
            </span>
            <span v-if="props.column.field == 'gender'">
              {{ props.row.gender + '' === '0' ? 'Female' : 'Male' }}
            </span>
            <span v-if="props.column.field == 'actions'">
              <button class="btn btn-md btn-success" @click="showModal = true">
                Pay Now &nbsp;
                <span class="fa fa-wrench"></span>
              </button>
            </span>
            <span v-else>{{ props.row[props.column.field] }}</span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import ArnergyInput from '../kitchen/ArnergyInput'

import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Dialog,
  RadioButton,
  // ...
} from 'element-ui'
import moment from 'moment'
moment.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_'),
})

const items = []
export default {
  components: {
    'el-dialog': Dialog,
    ArnergyInput,
  },
  data() {
    return {
      searchTerm: '',
      usertype: localStorage.roleType,
      showModal: false,
      selectOption: {
        enabled: true,
      },
      items: items,
      fields: [
        {
          field: 'id',
          label: 'ID',
          sortable: 'true',
        },
        {
          field: 'full_name',
          label: 'Full Name',
          sortable: 'true',
        },
        {
          field: 'roleType',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'email',
          label: 'E-mail',
          sortable: 'true',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: 'gender',
          label: 'Gender',
          sortable: 'true',
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: 'phoneNumber',
          label: 'Phone Number',
          sortable: 'true',
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: 'updatedAt',
          label: 'Last Seen',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
      ],
      cxTeamFields: [
        {
          field: 'id',
          label: 'ID',
          sortable: 'true',
        },
        {
          field: 'full_name',
          label: 'Full Name',
          sortable: 'true',
        },
        {
          field: 'roletype',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'email',
          label: 'E-mail',
          sortable: 'true',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: 'gender',
          label: 'Gender',
          sortable: 'true',
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: 'phonenumber',
          label: 'Phone Number',
          sortable: 'true',
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: 'updatedat',
          label: 'Last Seen',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
      ],
      cxTeamFieldsAdmin: [
        {
          field: 'id',
          label: 'ID',
          sortable: 'true',
        },
        {
          field: 'full_name',
          label: 'Full Name',
          sortable: 'true',
        },
        {
          field: 'roleType',
          label: 'User Type',
          sortable: 'true',
        },
        {
          field: 'email',
          label: 'E-mail',
          sortable: 'true',
        },
        // { key: 'dob', label: 'Date of birth', sortable: 'true'},
        {
          field: 'gender',
          label: 'Gender',
          sortable: 'true',
        },
        // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
        // { key: 'is_active', label: 'Status', sortable: 'true'},
        // { key: 'last_login', label: 'Last Login', sortable: 'true'},
        {
          field: 'phoneNumber',
          label: 'Phone Number',
          sortable: 'true',
        },
        // { key: 'address', label: 'Address', sortable: 'true'},
        {
          field: 'updatedAt',
          label: 'Last Seen',
          sortable: 'true',
        },
        {
          field: 'actions',
          label: 'Actions',
        },
      ],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: '',
        content: '',
      },
    }
  },
  computed: {
    ...mapGetters([
      'getUserById',
      'getDeviceById',
      'getUsers',
      'getUsersAdmin',
      'getDummy',
      'getDevices',
    ]),
    isACxTeam: {
      get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true
        } else {
          return true
        }
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {
            text: f.label,
            value: f.key,
          }
        })
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format('Do MMM YYYY')
    },
    navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user,
        },
      })
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    pressFunc() {
      console.log('i was presseed')
    },

    fetchUsers() {
      const HTTP = this.$httpUtils.instance
      //  filter={"include": ["installations"]}
      const url = `/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER`+`&filter[order]=id DESC`
      HTTP.get(url)
        .then((response) => {
          const usersList = response.data
          this.$store.commit('saveUsers', usersList)
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    fetchUsersAdmin() {
      const HTTP = this.$httpUtils.instance
      let data = new FormData()
      let id = localStorage.customerId
      data.append('customerAdminUserId', id)
      //  filter={"include": ["installations"]}
      const url = `/groupUsers/getUsersByCustomerAdmin`
      HTTP.post(url, data)
        .then((response) => {
          const usersList = response.data
          this.$store.commit('saveUsersAdmin', usersList)
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
  },
  mounted() {
    this.fetchUsersAdmin()
    this.fetchUsers()
    // console.log(this.getDummy)
  },
}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/_reduced_variables.scss';
.parent-box {
  position: relative;
}

.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  // color: $primary-color;
}

.space {
  margin: 20px 0;
  margin-left: 20px;
  color: #8f8d8c;

  span {
    color: black;
    font-weight: bold;
  }
}

.misbehave {
  margin: 50px auto 20px auto;
  max-width: 550px;
}

.checkbox-style {
  display: flex;
  // align-items: center;

  input,
  p {
    margin-right: 5px;
  }

  p {
    margin: 0;
  }
}

.packages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  div {
    margin: 10px;
  }
}

.footer {
  margin: 50px auto;
  max-width: 550px;
}

.flex {
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 5px;
  }
}

.intro-title {
  text-align: center;
  position: relative;

  .text {
    font-weight: bold;
    position: relative;
    z-index: 10;
    display: inline;
    background: #f9f9f9;
    padding: 0 20px;
  }

  &:before {
    width: 100%;
    height: 2px;
    background: #ebebeb;
    display: block;
    content: '';
    position: absolute;
    top: 10px;
    z-index: 0;
    // bottom: 0;
  }
}

.paying-now {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebebeb;
  padding: 10px 0;
  font-size: 24px;

  span {
    color: black;
    font-weight: bold;
  }

  span:first-child {
    font-size: 12px;
    margin-right: 10px;
  }
}

.footer-lock {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;

  .small {
    font-weight: bold;
    margin-left: 5px;
    color: black;
  }
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}

.card-title {
  font-size: 2.6rem;
}

table th,
table th span {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/payment/due_payments.vue